export default "__VITE_ASSET__kA8B5091__"